import { useTranslation } from "react-i18next";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { TProjectOverview } from "@/zapi-frontend/stores/project";
import { SectionCard } from "./SectionCard";

export function OpportunityFrameBlock({ overview }: { overview: TProjectOverview }) {
  const { t } = useTranslation("projectHome");
  const { opportunityFrame } = overview;
  if (!opportunityFrame.question && !opportunityFrame.verdict) return null;

  return (
    <SectionCard label={t("overview.opportunityFrame")} headerClassName="mb-3">
      <div className="flex flex-col gap-4">
        <FigmaTypography variant="body-2" color="zinc900">
          {opportunityFrame.question}
        </FigmaTypography>
        <div className="flex items-start border-l border-innoveraZinc-150 pl-5 py-3">
          <FigmaTypography variant="heading-5" className="flex-1 min-w-0 text-innoveraZinc-800">
            {opportunityFrame.verdict}
          </FigmaTypography>
        </div>
      </div>
    </SectionCard>
  );
}
